import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.DASHBOARD;

export const STATS = createActionName(reducerName, 'STATS');
export const ACTIVITIES = createActionName(reducerName, 'ACTIVITIES');
export const COURIERS_WITHOUT_ASSIGNMENT = createActionName(reducerName, 'COURIERS_WITHOUT_ASSIGNMENT');
export const COURIERS_WITHOUT_REASSIGNMENT = createActionName(reducerName, 'COURIERS_WITHOUT_REASSIGNMENT');
